import React from 'react';
import { Outlet } from 'react-router-dom';

import { OnboardingProvider } from './OnboardingContext';
import { alpha, Box, SxProps, Theme } from '@mui/material';
import { LangSelector } from '../uiComponents/CommonComponents/LangSelector';

const customStyles: Record<string, SxProps<Theme>> = {
  langSelectorContainer: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    zIndex: 1000,
    backgroundColor: 'white',
    borderRadius: '8px',
    '&.Mui-disabled': {
      backgroundColor: '#F3F5F9',
    },
    '& .MuiSelect-select': {
      padding: '6px 40px 6px 12px !important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
      border: (theme: Theme) => `1px solid ${theme.palette.secondary.light}`,
    },
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: (theme: Theme) => theme.palette.primary.main,
      },
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: (theme: Theme) => `1px solid ${theme.palette.primary.main}`,
        boxShadow: (theme: Theme) => `0 0 0 2px ${alpha(theme.palette.primary.main, 0.1)}`,
        outline: 'none',
      },
    },
    '&.MuiPaper-root': {
      borderRadius: '12px',
    },
  },
};
export const OnboardingLayout: React.FC = () => {
  return (
    <OnboardingProvider>
      <Box sx={customStyles.langSelectorContainer}>
        <LangSelector />
      </Box>
      <Outlet />
    </OnboardingProvider>
  );
};
